import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router';

type BackButtonProps = {
  link: string;
  label?: string;
};

export function BackButton({ link, label = 'Go back' }: BackButtonProps) {
  const navigate = useNavigate();

  return (
    <button
      onClick={() => navigate(link)}
      className="flex items-center gap-2 p-2 hover:bg-neutral-100 rounded-lg transition-colors cursor-pointer"
    >
      <ArrowLeft className="w-5 h-5" aria-hidden="true" />
      <span className="text-sm font-medium">{label}</span>
    </button>
  );
}
